import React from 'react'
import { PageTitle } from '../../components/PageTitle'
import Intro from './Intro'
import { Container } from 'react-bootstrap'
import Specialty from './Specialty'
import { ProductsInAction } from './ProductsInAction'
import { KeyBenefits } from './KeyBenefits'

export const Page = () => {
  return (
    <>
      <PageTitle
        title="Home"
        description="Your premier source for high-quality panel punches and metal fabrication tools. Explore our extensive collection of professional-grade tools for all your metalworking needs."
      />
      <Intro />
      <Container>
        <Specialty />
        <ProductsInAction />
        <KeyBenefits />
      </Container>
    </>
  )
}
